import http from "@/http"
import { PartCollectionParamsDto } from "@/interfaces/library/partCollection"

const PATH = "/product-pages"

export const getProductPageByIdentifier = async function(identifier: string) {
  return await http.get(`${PATH}/by-identifier`, { params: { identifier } })
}

export const getPartCollections = async function(
  id: number,
  params: PartCollectionParamsDto
) {
  const url = `${PATH}/${id}/part-collections`
  return await http.get(url, { params })
}

export const getPartsForCollection = async function(
  productPageId: number,
  partCollectionId: number
) {
  const url = `${PATH}/${productPageId}/part-collections/${partCollectionId}/parts`
  return await http.get(url)
}

export const searchPartsAcrossCollections = async function(
  productPageId: number,
  searchTerm: string
) {
  let offset = 0
  const getUrl = () => `product-pages/${productPageId}`
    + '/part-collections/search-parts'
    + `?offset=${offset}`
    + `&q=${searchTerm}`

  const collections: any[] = []
  let pageCount, pageNum

  do {
    const { data, headers } =  await http.get(getUrl())
    pageCount = parseInt(headers['x-page-count'])
    pageNum = parseInt(headers['x-page-num'])
    offset = parseInt(headers['x-offset']) + parseInt(headers['x-limit'])
    collections.push(...data.items)
  } while (pageNum < pageCount)

  return collections
}

export const getPartsAsXlsx = async function(
  productPageId: number,
  partCollectionId: number,
  headers: Record<string, string>
) {
  const headerTranslationsB64 = base64UrlEncodeUtf8Json(headers)
  const url =
    `${PATH}/${productPageId}` +
    `/part-collections/${partCollectionId}/xlsx` +
    `?headerTranslationsB64=${encodeURIComponent(headerTranslationsB64)}`

  return await http.get(url, {
    responseType: 'blob',
  })
}

function base64UrlEncodeUtf8Json(obj: Record<string, string>): string {
  const json = JSON.stringify(obj);
  const bytes = new TextEncoder().encode(json);

  let binary = "";
  for (const b of bytes) binary += String.fromCharCode(b);

  const base64 = btoa(binary);
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}
